import fetch from '@/util/http'

export default {
  couponActivity(model) {
    return fetch.get('coupon/activity', model)
  }
}



// WEBPACK FOOTER //
// ./src/api/coupon.js